module.exports = __webpack_public_path__ + "static/media/gray-right-arrow.f154cc93.svg";